import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function LegalAdminDashboard() {
  return (
    <Dashboard sidebarType="Legal">
      <DashboardConfig />
    </Dashboard>
  );
}
